const maybePluralize = (count, noun, suffix = "s", plural) => {
  const isPlural = [1, -1].indexOf(count);
  return plural ? (isPlural ? plural : noun) : noun + (isPlural ? suffix : "");
};

export default maybePluralize;
